<div class="modal-header">
  <h4 class="modal-title">
    @if (question) {
      Editar pregunta
    }
    @if (!question) {
      Nueva pregunta
    }
  </h4>
  <button 
    type="button" 
    class="btn-close" 
    aria-label="Close" 
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form
    id="formQuestion"
    [formGroup]="formQuestion"
    (ngSubmit)="onSubmit()">
    
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 form-group mb-4">
          <label 
            for="question" 
            class="form-label">
            Pregunta
          </label>
          <input
            type="text"
            class="form-control"
            formControlName="question"
            placeholder="Ingrese la pregunta"
            [ngClass]="{
              'is-invalid': submitted && f['question'].errors
            }">
          @if (submitted && f['question'].errors) {
            <div class="invalid-feedback">
              @if (f['question'].errors['required']) {
                Por favor, ingrese una pregunta
              }
            </div>
          }
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-outline-danger w-100">
      Cancelar
    </button>
  </div>
  <div class="col-12">
    <button
      type="submit"
      form="formQuestion"
      class="btn btn-primary w-100">
      {{ question ? 'Actualizar' : 'Registrar' }}
    </button>
  </div>
</div>
